import { create } from "zustand";
import { useEffect } from "react";

export const useToastStore = create((set) => ({
  toasts: [],
  add: (message, type = "success") => {
    const id = Date.now();
    set((s) => ({ toasts: [...s.toasts, { id, message, type }] }));
    setTimeout(() => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })), 4000);
  },
}));

export function toast(message, type = "success") {
  useToastStore.getState().add(message, type);
}

const COLORS = {
  success: { bg: "rgba(0,245,255,0.1)", border: "rgba(0,245,255,0.4)", text: "var(--color-cyan)" },
  error:   { bg: "rgba(255,51,85,0.1)",  border: "rgba(255,51,85,0.4)",  text: "var(--color-red)" },
};

export default function Toasts() {
  const toasts = useToastStore((s) => s.toasts);

  if (toasts.length === 0) return null;

  return (
    <div style={{ position: "fixed", top: 16, right: 16, zIndex: 9999, display: "flex", flexDirection: "column", gap: 8 }}>
      {toasts.map((t) => {
        const c = COLORS[t.type] || COLORS.success;
        return (
          <div key={t.id} style={{
            background: c.bg, border: `1px solid ${c.border}`, borderRadius: 6,
            padding: "10px 16px", color: c.text,
            fontFamily: "var(--font-mono)", fontSize: 12, letterSpacing: "0.04em",
            boxShadow: "0 4px 16px rgba(0,0,0,0.5)",
            animation: "toast-in 0.2s ease-out",
          }}>
            {t.message}
          </div>
        );
      })}
    </div>
  );
}
